<template>
  <span class="badge badge-warning" v-if="mode === 'view'">{{label}}</span>
</template>
<!--:options="listParams"-->
<!--@onChange="onValueChanged"-->


<script>
  import EventBus from "../_framework/bus.js";
  import * as $ from "jquery";
  import VsSelect from "../_framework/VsSelect";
  import Vue from "vue";
  export default {
    name: "set-default-value",
    props: {
      data: null,
      header: null,
      headerKey: null,
      mode: null,
      placeholder: null,
      type: null,
      row: null
    },
    data() {
      return {
        show: true,
        model: null,
        label: "",
        isMultiple: false,
        // listParams: {},
        options: null,
        selectedVal: {}
      };
    },
    components: {
      VsSelect
    },
    methods: {
      /*onValueChanged(val) {
        this.$emit("dataChanged", this.headerKey, val);
        EventBus.$emit("clientSelectChanged", val);
      },*/
      /*onKeyDown(event) {
        this.onValueChanged(event.target.value);
        EventBus.$emit("debtorChange", event);
        if (this.type === "number" && event.key === "e") {
          event.preventDefault();
          return;
        }
        this.$nextTick(() => {
          if (event.target.value === this.lastValue) {
            return;
          }
          this.lastValue = event.target.value;
        });
      },*/
      mountVSelect() {

        // this.label = this.header.label;
        // this.options = this.header.data;
        if (this.mode !== "create") {
          if (this.data === true) {
            this.label = "پیش فرض";
          } else {
            this.label = "-";
          }
        }
        /*if (this.mode === "view" && this.header) {
          if (typeof this.data === "boolean") {
            if (this.data === true) {
              this.label = "پیش فرض"
            } else {
              this.label = "-"
            }
            /!*this.header.data.map(d => {
              if (d.persianName === this.data) {
                this.selectedVal = d;
                this.onValueChanged(d);
              }
            });*!/
          }
        }*/
        if (this.header.listParams) {
          this.listParams = this.header.listParams;
        } else {
          this.listParams = null;
        }
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    mounted() {
      // this.data = false;
      this.mountVSelect();
    },
    computed: {},
    watch: {
      mode(val) {
        if (val === "edit" || val === "view") {
          this.mountVSelect();
        }
      }
    }
  };
</script>

<style scoped>
  #debtor::placeholder {
    text-align: center;
  }
</style>
